import { Component, Inject, OnInit, OnDestroy } from '@angular/core';

import { Store } from '@src/store';
import { SessionService } from '@src/services';
import { projectActions } from '@src/store/reducers/projectReducer';

@Component({
    selector: 'sub-menu',
    template: require('./sub-menu.component.html'),
    styles: [require('./sub-menu.component.scss')]
})
export class SubMenuComponent implements OnInit, OnDestroy {
    public display = false;
    public isDbmaestroCmsProject = false;
    public isJiraCmsProject = false;
    public items: any[];
    private unsubscribe: any;
    private unsubscribeCMS: any;
    private params: any;
    public dbFlags: any;
    public tempDbTypeId: any;

    private menuItems = {
        Environments: 'app.authorized.environments',
        Packages: 'app.authorized.packages',
        Configurations: 'app.authorized.configurationsView',
        Hooks: 'app.authorized.hooks',
        Backups: 'app.authorized.backups',
        'DBmaestro Task Manager': 'app.authorized.taskManager',
        'CMS Query Task Manager': 'app.authorized.cmsTaskManager',
        'Object Scope' : 'app.authorized.objectExclusion',
        'Static Content' : 'app.authorized.staticContent',
        'Release Variable' : 'app.authorized.releaseVariable'
    };

    constructor(
        @Inject('$scope') private $scope: any,
        @Inject('dbTypeService') private dbTypeService: any,
        public store: Store,
        @Inject('$state') public $state: any,
        @Inject('$stateParams') private $stateParams: any,
        private sessionService: SessionService) {
    }

    public ngOnInit() {
        this.unsubscribeCMS =  this.store.subscribe(async() => {
            this.isDbmaestroCmsProject = false;
            this.isJiraCmsProject = false;
            const projectsState = this.store.getState().projects;
            
            //oleg changed === to == need to fix later
            if (projectsState && projectsState.projectWithMetaData)
            {
                const tempDbTypeId = projectsState.projectWithMetaData.dbTypeId;
                this.dbFlags = await this.dbTypeService.getFlags(tempDbTypeId);
             }
            if (projectsState && projectsState.projectWithMetaData
                && projectsState.projectWithMetaData.connectedCmsProject
                && parseInt(this.$stateParams.id) === projectsState.projectWithMetaData.id) 
                {
                    this.isDbmaestroCmsProject = false;
                    this.isJiraCmsProject = false;
                if (projectsState.projectWithMetaData.connectedCmsProject.isManagedQueries) {
                    this.isJiraCmsProject = true;
                }
                if (projectsState.projectWithMetaData.connectedCmsProject.cmsTypeName === 'DBMAESTRO') {
                    this.isDbmaestroCmsProject = true;
                }
            }
        });
        const states = [
            'app.authorized.environments',
            'app.authorized.packages',
            'app.authorized.configurationsView',
            'app.authorized.hooks',
            'app.authorized.objectExclusion',
            'app.authorized.staticContent',
            'app.authorized.releaseVariable',
            'app.authorized.backups',
            'app.authorized.taskManager',
            'app.authorized.cmsTaskManager'
        ];
        this.unsubscribe = this.store.subscribe(() => {
            this.display = false;
            const modules = this.store.getState().user.userModules;
            if (modules != null && states.includes(this.$state.current.name)) {
                this.params = this.$state.params;
                this.display = true;
                modules.filter((x: any) => x.name === 'Projects').forEach((item: any) => {
                    if(this.dbFlags){
                        if(this.dbFlags.HasDevEnv == false && this.dbFlags.HasValidate==false){
                            this.items = item.subModules.filter((sm:any)=> sm.name != 'Object Scope');
                        }
                        else{
                            this.items = item.subModules;
                        }
                    }
                    if(this.items){
                        this.items.forEach((i) => {
                            i.sref = this.menuItems[i.name];
                        });
                    }
                });
            }
        });
        this.$scope.$watch(() => this.$state.$current.name, (newVal: any, oldVal: any) => {
            if (oldVal !== null && !states.includes(newVal)) {
                this.display = false;
            }
        });
    }

    public ngOnDestroy() {
        this.unsubscribeCMS();
        this.unsubscribe();
    }

    public isSelectedTab(item: any) {
        return item.sref === this.$state.current.name;
    }
    //adding tabs to be hidden when clicking edit
    public isDisabled(item: any) {
        let flagDisable = false;
        try {
            const state = this.store.getState();
            const isDraft = state.project.editMode || state.projects.projectWithMetaData.isDraft;
            if (isDraft
                && (item === 'Packages'
                || item === 'Hooks'
                || item === 'DBmaestro Task Manager'
                || item === 'CMS Query Task Manager'
                || item === 'Backups'
                || item === 'Object Scope'
                || item === 'Static Content'
                || item === 'Release Variable')) {
                flagDisable = true;
            }
        } catch (e) { }
        return flagDisable;
    }

    public async editMode() {
        const response = await this.store.dispatch({
            type: projectActions.GET_EDIT_PROJECT,
            payload: { projectId: this.$stateParams.id }
        });
        const isNew = response.data.isNew;
        const projectWithMetaData = this.store.getState().projects.projectWithMetaData;
        if (parseInt(this.$stateParams.id) === projectWithMetaData.id && !projectWithMetaData.isDraft) {
            const stateName = `${response.data.name} (Draft)`;
            this.sessionService.set(`project_${response.data.id}`, stateName);
            const nextState = this.$state.current.name === 'app.authorized.configurationsView'
                ? this.$state.current.name
                : 'app.authorized.environments';
            const stateData = {
                id: response.data.id,
                name: stateName,
                isNewDraft: response.data.isNew
            };
            this.$state.go(nextState, stateData);
        }
        this.store.dispatch({
            type: projectActions.SET_EDIT_MODE,
            payload: { editMode: true, isNewDraft: isNew }
        });
    }

    public navigate(event: any, sref: any) {
        event.preventDefault();
        this.$state.go(sref, this.params);
    }

    public generateUrl(item): string {
        return `/#/project/${this.params.id}/${item?.replace('app.authorized.', '')}`;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/sub-menu/sub-menu.component.ts